import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Box, Typography, CircularProgress, Alert } from "@mui/material";
import PayHereComponent from "pages/appointmentByAdmin/payHereComponent";

export default function ExternalMedicalReport() {
    const { reportLink } = useParams(); // Extract the report link from the URL
    const [reportDetails, setReportDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [paymentStatus, setPaymentStatus] = useState(null);

    useEffect(() => {
        // Fetch report details using the reportLink
        const fetchReportDetails = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}external/report/${reportLink}`
                );
                setReportDetails(response.data);
                setLoading(false);
            } catch (err) {
                setError("Failed to retrieve the report. Please check the link or try again later.");
                setLoading(false);
            }
        };

        fetchReportDetails();
    }, [reportLink]);

    const handlePaymentSuccess = () => {
        setPaymentStatus("Payment successful. You can now access the report.");
        // Optionally, refresh the report details to reflect the payment status
        // fetchReportDetails();
    };

    const handlePaymentError = (error) => {
        setPaymentStatus(`Payment failed: ${error}`);
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <Alert severity="error">{error}</Alert>
            </Box>
        );
    }

    if (reportDetails.expired) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <Alert severity="warning">This report link has expired.</Alert>
            </Box>
        );
    }

    return (
        <Box p={3}>
            <Typography variant="h4" gutterBottom>
                Medical Report Access
            </Typography>
            <Typography variant="body1" gutterBottom>
                Report ID: {reportDetails.id}
            </Typography>
            <Typography variant="body1" gutterBottom>
                Patient Name: {reportDetails.patientName}
            </Typography>
            <Typography variant="body1" gutterBottom>
                Price: LKR {reportDetails.price}
            </Typography>
            <Typography variant="body1" gutterBottom>
                Status: {reportDetails.paid ? "Paid" : "Pending Payment"}
            </Typography>

            {!reportDetails.paid && (
                <PayHereComponent
                    sandbox={true} // Set to false for production
                    merchant_id={process.env.REACT_APP_PAYHERE_MERCHANT_ID}
                    return_url={`${window.location.origin}/payment-success`}
                    cancel_url={`${window.location.origin}/payment-cancel`}
                    notify_url={`${process.env.REACT_APP_BACKEND_URL}payment/notify`}
                    order_id={reportDetails.id}
                    items="Medical Report Access"
                    amount={reportDetails.price}
                    currency="LKR"
                    first_name="Guest"
                    last_name="Patient"
                    email="guest@example.com"
                    phone="0000000000"
                    address="N/A"
                    city="N/A"
                    country="Sri Lanka"
                    onCompleted={handlePaymentSuccess}
                    onError={handlePaymentError}
                />
            )}

            {paymentStatus && (
                <Alert severity={paymentStatus.includes("successful") ? "success" : "error"} sx={{ mt: 2 }}>
                    {paymentStatus}
                </Alert>
            )}

            {reportDetails.paid && (
                <Box mt={3}>
                    <Typography variant="h6">Report Details:</Typography>
                    <iframe
                        src={reportDetails.reportUrl}
                        width="100%"
                        height="600px"
                        title="Medical Report"
                    ></iframe>
                </Box>
            )}
        </Box>
    );
}
